import React from "react";
import './EmployeeListInfo.css';
import DataTable from 'react-data-table-component';
import { FiEdit3, FiTrash2 } from "react-icons/fi";

const EmployeeListInfo = ({ employeeDetails ,handleRegisterEmployee,handleDelete ,handleEdit}) => {

     const tableHeaderStyle = {
        headCells: {
            style: {
                height: "90px",
                fontWeight: 760,
                fontSize: "16px",
                backgroundColor: "white",
                lineHeight: "19.2px",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                textAlign: "left",
                borderBottom: "none"
            },
        },
    };

    const columns = [
        {
            name: "Name",
            selector: (row) => `${row.firstName} ${row.lastName}`, // added space
        },
        {
            name: "Email",
            selector: (row) => row.emailId,
        },
        {
            name: "Mobile Phone",
            selector: (row) => row.mobileNumber,
        },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <FiEdit3
                        title="Edit"
                        aria-label="Edit"
                        style={{
                            width: "38px",
                            height: "25px",
                            padding: "2px",
                            cursor: "pointer",
                        }}
                        onClick={(e) => handleEdit(e, true,row.emailId,row.empRegistrationID ,row.empId)}
                    />
                    <FiTrash2
                        title="Delete"
                        aria-label="Delete"
                        style={{
                            width: "38px",
                            height: "25px",
                            padding: "2px",
                            cursor: "pointer",
                        }}
                        onClick={(e) => handleDelete(e, row)}
                    />
                </>
            ),
        },
    ];

    return (
        <div className="container-fluid p-0">
            <div className="lotmanagement">
                <div className="row align-items-center">
                    <div className="col d-flex justify-content-start">
                        <p className="employee-title">Employees</p>
                    </div>
                    <div className="col d-flex justify-content-end">
                        <button className="btn btn-primary" onClick={(e)=>{handleRegisterEmployee(e,true)}}>Add New Employees</button>
                    </div>
                </div>

                <div className="row">
                    <div className="col d-flex justify-content-start">
                        <p className = "employee-content">
                            Add and manage sub-owners who can help you manage your parking properties.
                        </p>
                    </div>
                </div>

                <React.Fragment>
                    <DataTable
                        customStyles={{
                                        headCells: tableHeaderStyle.headCells,
                                        cells: {
                                            style: {
                                                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                                                fontSize: '14px',
                                                fontWeight: '400',
                                                lineHeight: '18.6px',
                                                textAlign: 'left',
                                                height: "50px",
                                                borderBottom: "none"
                                            },
                                        },
                                    }}
                        pagination
                        highlightOnHover
                        columns={columns}      
                        data={employeeDetails} 
                    />
                </React.Fragment>
            </div>
        </div>
    );
};

export default EmployeeListInfo;
